<template>
    <b-container fluid="">
        <b-button type="button" id="btn_flotante_agregar_ficha_sucursal" size="sm" variant="outline-dark"
            v-if="permisos['sucursales.productos']?.crear || ES_ROOT" @click="abrir_modal_crear_articulo">
            <i class="fas fa-plus"></i> Crear Producto
        </b-button>
        <b-button type="button" id="btn_flotante_agregar_ficha_sucursal" size="sm" variant="outline-dark" v-else
            disabled>
            <i class="fas fa-plus"></i> Crear Producto
        </b-button>

        <b-row>
            <div class="col-sm-12 mt-1">
                <h3>
                    Lista de productos
                </h3>
            </div>
            <div class="col-sm-12 mt-1">
                <div class="marco_lista_productos">
                    <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                        <thead>
                            <tr>
                                <th style="width: 20%;text-align: center;">
                                    Código
                                </th>
                                <th style="width:20%;">
                                    Nombre
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Precio costo
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Precio venta
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Precio efectivo
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in lista_articulos" :key="index">
                                <td style="text-align: center;">
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    Q{{ item.precio_costo }}
                                </td>
                                <td style="text-align: center;">
                                    Q{{ item.precio_venta }}
                                </td>
                                <td style="text-align: center;">
                                    Q{{ item.precio_efectivo }}
                                </td>
                                <td style="text-align: center;">
                                    <b-button type="button" size="sm" style="font-size:10px;margin-right: 5px;"
                                        variant="outline-dark" v-if="permisos['sucursales.productos']?.ver || ES_ROOT"
                                        @click="abrir_modal_edicion(item)">
                                        <i class="fas fa-info-circle"></i>
                                    </b-button>
                                    <b-button type="button" size="sm" style="font-size:10px;margin-right: 5px;"
                                        variant="outline-dark" v-else disabled>
                                        <i class="fas fa-info-circle"></i>
                                    </b-button>

                                    <b-button type="button" size="sm" style="font-size:10px;" variant="outline-dark"
                                        v-if="permisos['sucursales.productos']?.borrar || ES_ROOT"
                                        @click="borrar_articulo(item.documentId)">
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                    <b-button type="button" size="sm" style="font-size:10px;" variant="outline-dark"
                                        v-else disabled>
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </b-row>

        <FormularioEdicionProducto v-if="modal_edicion_producto" @salir="cerrar_modal_edicion"
            v-on:actualizar_producto="obtener_productos_de_sucursal" />

        <FormularioCrearProducto v-if="modal_crear_articulo" :modulo_del_que_viene="'sucursales'"
            @salir="cerrar_modal_crear_articulo" v-on:actualizar_lista_productos="obtener_productos_de_sucursal" />

    </b-container>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import FormularioEdicionProducto from './EditarProducto.vue';
    import FormularioCrearProducto from '../../Inventario/Articulo/CrearArticulo.vue'
    import { minix, pregunta } from '@/components/functions/alertas';

    export default {
        name: 'ListaProductos',
        computed: {
            ...mapState(['sucursal_seleccionada', 'permisos', 'datos_usuario', 'id_empresa_seleccionada']),
            ...mapGetters(['ES_ROOT'])
        },
        components: {
            FormularioEdicionProducto,
            FormularioCrearProducto
        },
        data() {
            return {
                lista_articulos: [],
                modal_edicion_producto: false,
                modal_crear_articulo: false
            }
        },
        methods: {
            async obtener_productos_de_sucursal() {
                /* let f = {
                    api: `articulos?filters[sucursal][$eq][0]=${this.sucursal_seleccionada.codigo}&filters[activo][$eq][1]=true&filters[empresa][$eq][2]=${this.id_empresa_seleccionada}&filters[formula][$eq][3]=false`
                } */

                let f = {
                    api:`articulos/c/articulos-por-sucursal?sucursal=${this.sucursal_seleccionada.codigo}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f)
                if (r.length == 0) {
                    minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 2000 })
                } else {
                    this.lista_articulos = r
                }
            },
            abrir_modal_edicion(item) {
                this.set_producto_seleccionado(item)
                this.modal_edicion_producto = true
            },
            async borrar_articulo(document) {

                pregunta({ titulo: 'Seguro que borrar el producto?', texto: 'Se trasladará a la papelera, y se borrrará definitivamente en 30 dias', afirmacion: 'Si, borrar!' }, async (i) => {


                    if (i) {
                        let f = {
                            api: `articulos/${document}`,
                            formulario: {
                                activo: false
                            }
                        }

                        await this.actualizar_data(f)
                        await this.obtener_productos_de_sucursal()
                    }
                })


            },
            cerrar_modal_edicion() {

                this.modal_edicion_producto = false
            },
            abrir_modal_crear_articulo() {
                this.modal_crear_articulo = true
            },
            cerrar_modal_crear_articulo() {
                this.modal_crear_articulo = false
            },
            ...mapActions(['obtener_data', 'actualizar_data']),
            ...mapMutations(['set_producto_seleccionado'])
        },
        mounted() {
            this.obtener_productos_de_sucursal()
        },
    }
</script>

<style>
    .marco_lista_productos {
        width: 100%;
        height: 420px;
        overflow: auto;
    }

    #btn_flotante_agregar_ficha_sucursal {
        position: absolute;
        top: 5px;
        right: 30px;
        z-index: 999;
    }
</style>
